module.exports = __webpack_public_path__ + "static/media/Electrike_gaussian2.24590309.png";